import monteTrialClassImage from '../../../../../public/img/blog-install-home-monte.webp';
import { FontSize } from '../../../../constants/FontSize';
import { PageUrl } from '../../../../constants/PageUrl';
import { SectionId } from '../../../../constants/SectionId';
import Color from '../../../../styles/Color';
import SectionTitle from '../../atoms/SectionTitle';
import { SectionWrapper } from '../../templates/SectionWrapper';
import { CircleImageWithLink } from './CircleImageWithLink';
import styles from './monte-trial-class-introduction.module.scss';

export const MonteTrialClassIntroduction = () => (
  <SectionWrapper id={SectionId.DAYCARE_MONTE_TRIAL_CLASS_INTRO} backgroundColor={Color.brandBlue50}>
    <SectionTitle fontSize={FontSize.MEDIUM} variant="border">
      入園前に、わが子との相性を確かめる
      <br />
      モンテ園体験クラス
    </SectionTitle>
    <div className={styles['content-wrapper']}>
      <p className={styles['body-text']}>
        月1回・少人数制の親子参加型クラスで、モンテッソーリ環境にいるお子さまの様子を実際に見ながら「この園はわが家に合うか」を確かめていただけます。
        <br />
        <br />
        モンテッソーリ歴20年以上の教師が、お子さまひとりひとりの様子を見ながら丁寧にご案内します。
        <br />
        <br />
        初めての場所が不安なお子さまも、まずは親子で環境に慣れるところから始められます。初回は無料でご利用いただけます。
      </p>
      <CircleImageWithLink
        label="体験クラスを詳しく見る →"
        href={PageUrl.DAYCARE_MONTE_TRIAL_CLASS}
        imageSrc={monteTrialClassImage}
        color={Color.brandBlue}
      />
    </div>
  </SectionWrapper>
);
